module.exports = __webpack_public_path__ + "static/media/Find Practice.fa3a2c67.webp";